import * as Types from '../../../generated.types'

import { PageInfoFragmentDoc } from '../../../fragments/PageInfoFragment_gen'
import {
  BankingTransactionFragmentDoc,
  ReimbursementClaimFragmentDoc,
} from '../../../fragments/BankingTransactionFragment_gen'
import { BankingAccountFragmentDoc } from '../../../fragments/BankingAccountFragment_gen'
import { ErrorFragmentDoc } from '../../../fragments/ErrorFragment_gen'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { fetchGql } from '@alice-financial/api'
export type BankingTransactionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']>
  after?: Types.InputMaybe<Types.Scalars['String']>
  last?: Types.InputMaybe<Types.Scalars['Int']>
  before?: Types.InputMaybe<Types.Scalars['String']>
  confirmationStatus?: Types.InputMaybe<Types.ConfirmationStatusValue>
}>

export type BankingTransactionsQuery = {
  __typename?: 'Query'
  bankingTransactions: {
    __typename?: 'BankingTransactionConnection'
    pageInfo: {
      __typename?: 'PageInfo'
      startCursor?: string | null
      endCursor?: string | null
      hasNextPage: boolean
      hasPreviousPage: boolean
    }
    nodes?: Array<{
      __typename?: 'BankingTransaction'
      id: string
      amount: number
      date: string
      estimatedSavings: number
      name: string
      merchantName?: string | null
      spendEligibility: {
        __typename?: 'SpendEligibility'
        confirmedPartialAmount?: number | null
        pretaxCategory: Types.PretaxCategory
        autoConfirmedAt?: string | null
        isDisconfirmable?: boolean | null
        confirmationStatus: {
          __typename?: 'ConfirmationStatus'
          updatedAt?: string | null
          value: Types.ConfirmationStatusValue
        }
      }
      account:
        | {
            __typename: 'BankingAccount'
            id: number
            billingSystemId?: string | null
            name?: string | null
            cardType?: Types.BankCardType | null
            accountType?: Types.BankingAccountType | null
            platform: Types.BankingAccountPlatform
            accountLast4?: string | null
            error?: { __typename?: 'Error'; message?: string | null; code?: string | null } | null
          }
        | { __typename: 'CashPaymentAccount' }
      reimbursementClaim?: {
        __typename?: 'ReimbursementClaim'
        approvalStatus: Types.ReimbursementClaimApprovalStatus
        reviewedAt?: string | null
      } | null
      reimbursementStatus?: { __typename?: 'ReimbursementStatus'; isFullyReimbursed: boolean } | null
    } | null> | null
  }
}

export const BankingTransactionsDocument = `
    query BankingTransactions($first: Int, $after: String, $last: Int, $before: String, $confirmationStatus: ConfirmationStatusValue) {
  bankingTransactions(
    first: $first
    after: $after
    last: $last
    before: $before
    confirmationStatus: $confirmationStatus
  ) {
    pageInfo {
      ...PageInfo
    }
    nodes {
      ...BankingTransaction
    }
  }
}
    ${PageInfoFragmentDoc}
${BankingTransactionFragmentDoc}
${BankingAccountFragmentDoc}
${ErrorFragmentDoc}
${ReimbursementClaimFragmentDoc}`
export const useBankingTransactionsQuery = <TData = BankingTransactionsQuery, TError = Error>(
  variables?: BankingTransactionsQueryVariables,
  options?: UseQueryOptions<BankingTransactionsQuery, TError, TData>
) =>
  useQuery<BankingTransactionsQuery, TError, TData>(
    variables === undefined ? ['BankingTransactions'] : ['BankingTransactions', variables],
    fetchGql<BankingTransactionsQuery, BankingTransactionsQueryVariables>(
      BankingTransactionsDocument,
      variables
    ),
    options
  )

useBankingTransactionsQuery.getKey = (variables?: BankingTransactionsQueryVariables) =>
  variables === undefined ? ['BankingTransactions'] : ['BankingTransactions', variables]
